/*                                                 *\
** ----------------------------------------------- **
**          Calliope - Pixos Game Engine   	       **
** ----------------------------------------------- **
**  Copyright (c) 2020-2022 - Kyle Derby MacInnis  **
**                                                 **
**    Any unauthorized distribution or transfer    **
**       of this work is strictly prohibited.      **
**                                                 **
**               All Rights Reserved.              **
** ----------------------------------------------- **
\*                                                 */
import pixosEngine from "pixos-engine";
let Modules = pixosEngine['pixos-engine'].Modules;

let Vector = Modules.utils.math.vector
let AirElemental = Modules.sprites.monsters.air_elemental;
let ActionLoader = Modules.utils.loaders.ActionLoader;
export default class MyAirElemental extends AirElemental {
  constructor(engine) {
    // Initialize Sprite
    super(engine);
  }
  // hook init
  async interact(sprite, finish) {
    try {
      await this.zone.moveSprite(this.id, [10, 11, this.zone.getHeight(10, 11)], false);
      if (finish) finish(true);
    } catch (e) {
      console.log("error", e);
    }
  }
  // hook init
  init() {
    let ret = new ActionLoader(
      this.engine,
      "patrol",
      [this.pos.toArray(), [7, 7, this.zone.getHeight(7, 7)], 200, this.zone],
      this,
      (x) => {
        console.log("sssss", x);
      }
    );
    console.log("---->HERE", ret);
    this.addAction(ret);
  }
}
